import React, { useState, useEffect } from "react";

import { HashLoader } from "react-spinners";
import Frontpage from "./pages/public/frontpage";
import Blog from "./pages/public/blog";
import Article from "./pages/public/article";
import BBArticleOne from "./components/public/articles/slik-brukte-bb-marketing-leadsurf-for-a-skaffe-nye-kunder-og-oke-salget";
import LoginPage from "./pages/public/login";
import InvitationPage from "./pages/public/invitation-page";
import RegisterPageFirstStep from "./pages/public/register-page-first-step";
import RegisterPageFinalStep from "./pages/public/register-page-final-step";
import DeliveryPage from "./pages/public/delivery-page";
import ForgotPassword from "./pages/public/forgot-password";
import ChangeDetails from "./pages/public/change-details";
import DashboardValidatePage from "./pages/dashboard/validate";
import DashboardClientsPage from "./pages/dashboard/clients";
import DashboardListsPage from "./pages/dashboard/company-lists";
import DashboardCampaignsPage from "./pages/dashboard/campaigns";
import DashboardContactListsPage from "./pages/dashboard/contact-lists";
import DashboardTemplatesPage from "./pages/dashboard/templates";
import DashboardSingleTemplatePage from "./pages/dashboard/single-template";
import DashboardNewTemplatePage from "./pages/dashboard/new-template";
import DashboardHelpCenter from "./pages/dashboard/help-center";

import Cookies from "./pages/public/cookies";
import PrivacyPolicy from "./pages/public/privacy-policy";
import Terms from "./pages/public/terms";
import NotFound from "./pages/public/not-found";

import DashboardSingleClientPage from "./pages/dashboard/single-client";
import DashboardSingleListPage from "./pages/dashboard/single-company-list";
import DashboardPipelinePage from "./pages/dashboard/pipeline";
import DashboardNewListPage from "./pages/dashboard/new-list";
import DashboardAccountPage from "./pages/dashboard/account";
import DashboardBusinessPage from "./pages/dashboard/company";
import DashboardOverviewPage from "./pages/dashboard/overview";
import DashboardLibraryPage from "./pages/dashboard/library";

import {
  Route,
  Switch,
  Redirect,
  useLocation,
  useHistory,
} from "react-router-dom";
import { auth } from "./networking/firebase";
import { useDispatch } from "react-redux";
import { retrieveUserDetails, flushDetails } from "./redux/actions/user";
import PricesPage from "./pages/public/prices";
import DashboardDeliveriesPage from "./pages/dashboard/deliveries";
import DashboardSingleContactListPage from "./pages/dashboard/single-contact-list";

const Index = ({ isLoading, setIsLoading }) => {
  const [activeUser, setActiveUser] = useState(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        if (
          (user && location && !location.pathname.includes("/registrer")) ||
          !location.pathname.includes("/invitasjon/")
        ) {
          dispatch(retrieveUserDetails(user.uid));
          setActiveUser(user);
          setIsLoading(false);
        } else {
          setActiveUser(null);
          dispatch(flushDetails());
          setIsLoading(false);
        }
      } else {
        setActiveUser(null);
        dispatch(flushDetails());
        if (location.pathname.includes("/dashboard/")) {
          history.push("/logg-inn");
        }
        setIsLoading(false);
      }
    });
  }, []);

  const PrivateRoute = ({ component, path, ...rest }) => {
    if (
      (activeUser !== null &&
        location &&
        !location.pathname.includes("/registrer")) ||
      !location.pathname.includes("/invitasjon/")
    ) {
      return <Route component={component} path={path} {...rest} />;
    } else {
      return <Redirect to="/logg-inn" {...rest} />;
    }
  };

  if (isLoading) {
    return (
      <div className="loading-indicator">
        <HashLoader size={80} color={"#123abc"} loading={isLoading} />
      </div>
    );
  } else {
    return (
      <Switch>
        <Redirect from="/:url*(/+)" to={location.pathname.slice(0, -1)} />
        <Route exact path="/" component={() => <Frontpage />} />
        <Route exact path="/blogg" component={() => <Blog />} />
        <Route
          exact
          path="/blogg/slik-brukte-bb-marketing-leadsurf-for-å-skaffe-nye-kunder-og-øke-salget"
          component={() => <Article Content={() => <BBArticleOne />} />}
        />
        <Route exact path="/logg-inn" component={() => <LoginPage />} />
        <Route
          exact
          path="/registrer/:id?"
          component={() => <RegisterPageFirstStep />}
        />
        <Route
          exact
          path="/registrer/valider/:id?"
          component={() => <RegisterPageFinalStep />}
        />
        <Route
          exact
          path="/invitasjon/:id?"
          component={() => <InvitationPage />}
        />
        <Route exact path="/levering/:id" component={() => <DeliveryPage />} />
        <Route
          exact
          path="/glemt-passord"
          component={() => <ForgotPassword />}
        />
        <Route
          exact
          path="/endre/:action?"
          component={() => <ChangeDetails />}
        />
        <Route exact path="/cookies" component={() => <Cookies />} />
        <Route exact path="/personvern" component={() => <PrivacyPolicy />} />
        <Route exact path="/priser" component={() => <PricesPage />} />
        <Route exact path="/vilkår" component={() => <Terms />} />
        <PrivateRoute
          exact
          path="/dashboard/oversikt"
          component={() => <DashboardOverviewPage />}
        />
        <PrivateRoute
          path="/dashboard/bibliotek"
          component={() => <DashboardLibraryPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/utsendelser"
          component={() => <DashboardCampaignsPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/kontaktlister"
          component={() => <DashboardContactListsPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/kontaktliste/:id"
          component={() => <DashboardSingleContactListPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/maler"
          component={() => <DashboardTemplatesPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/maler/ny"
          component={() => <DashboardNewTemplatePage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/mal/:id"
          component={() => <DashboardSingleTemplatePage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/pipeline"
          component={() => <DashboardPipelinePage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/leveranser"
          component={() => <DashboardDeliveriesPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/kunder"
          component={() => <DashboardClientsPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/kunde/:id"
          component={() => <DashboardSingleClientPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/lister"
          component={() => <DashboardListsPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/liste/:id"
          component={() => <DashboardSingleListPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/lister/ny"
          component={() => <DashboardNewListPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/hjelpesenter"
          component={() => <DashboardHelpCenter />}
        />
        <PrivateRoute
          exact
          path="/dashboard/konto"
          component={() => <DashboardAccountPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/foretak"
          component={() => <DashboardBusinessPage />}
        />
        <PrivateRoute
          exact
          path="/dashboard/valider/:id"
          component={() => <DashboardValidatePage />}
        />
        <Route component={() => <NotFound />} />
      </Switch>
    );
  }
};

export default Index;
